import { Pipe, type PipeTransform } from '@angular/core';
import { TableBtn, TableColumn, TableDataItem, TableItemValue } from '../components/table/table.model';
import _ from 'lodash';
import { Progression, Relapse } from 'src/app/features/medical-record/medical-record-page/pages/chemotherapy/model/treatment.interface';

@Pipe({
  name: 'asTableBtns',

})
export class AsTableBtns implements PipeTransform {

  transform(value: TableItemValue, ...args: unknown[]): TableBtn[] {
    if (!Array.isArray(value)) {
      return []
    }
    return value as TableBtn[]
  }

}

@Pipe({
  name: 'generateGridTemplate',

})
export class GenerateGridTemplate implements PipeTransform {


  transform(columns: TableColumn[], ...args: unknown[]): string {

    if (columns.length >= 3) {
      return `grid-template-columns: min-content repeat( ${(columns.length - 2)}, minmax(auto , calc(100% / ${(columns.length - 2)}))) min-content;`
    }
    return `grid-template-columns: min-content repeat( ${(columns.length - 1)}, minmax(auto , calc(100% / ${(columns.length - 1)})));`



  }

}

@Pipe({
  name: 'asMultValues',

})
export class AsMultValues implements PipeTransform {

  transform(value: TableItemValue, ...args: unknown[]): string[] {
    if (!Array.isArray(value) || value.length == 0) {
      return []
    }
    return value as string[]
  }

}

// Quantas linhas esse item deve ocupar numa tabela, usado para quando uma celula possui n valores, ex: 'tipo/local' em sinais vitais
@Pipe({
  name: 'rowsToSpan',

})
export class RowsToSpan implements PipeTransform {

  transform(value: TableDataItem, col: TableColumn[]) {
    const multipleValues = col
      .filter( ({type}) => type == 'multiple-values' ) // pegar somente chaves/colunas de multiplos valores
      .map( i => i.key) // somente as chaves importam
      .map( key => (value[key] as string[]).length ) // conseguir os valores que são listas e o length deles (quantas linhas ocupam)

    return _.max(multipleValues)
  }

}

@Pipe({
  name: 'progressionPipe',

})
export class ProgressionPipe implements PipeTransform {

  transform(data: Progression) {
    return data?.diseaseProgressionType ? 'Sim' : 'Não';
  }

}

@Pipe({
  name: 'relapsePipe',

})
export class RelapsePipe implements PipeTransform {

  transform(data: Relapse) {
    return data?.relapseType ? 'Sim' : 'Não';
  }

}